<ng-container>
    <h1 mat-dialog-title
        class="draggable-dialogue-header title-h"
        cdkDrag
        cdkDragRootElement=".cdk-overlay-pane"
        cdkDragHandle>
        {{this.Title}}
    </h1>

    <div mat-dialog-content
         *ngIf="this.WrapFieldsInDoubleQuotesFormControl != null">

        <mat-checkbox [formControl]="this.WrapFieldsInDoubleQuotesFormControl"
                      matTooltip="{{this.WrapFieldsInDoubleQuotesTooltip}}"
                      [matTooltipPosition]="this.TooltipPosition">Wrap Field Data In Double Quotes?</mat-checkbox>

        <p class="download-note-p">Note:  data will export to your downloads folder</p>
    </div>

    <div mat-dialog-actions>
        <button mat-flat-button
                type="submit"
                color="primary"
                class="theme-primary-btn"
                [disabled]="false"
                (click)="this.exportClicked()">
            Export
        </button>

        <button mat-flat-button
                [disabled]="false"
                style="margin-left: 10px;"
                [mat-dialog-close]="null">
            Cancel
        </button>
    </div>

</ng-container>
